module.exports = __webpack_public_path__ + "img/pic_administration_operate_2.5d5eeb84.png";